import React from 'react';
import PropTypes from 'prop-types';
import { Col, Dropdown, DropdownButton, Row } from 'react-bootstrap-5';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import StatusLabel from 'components/status_label';
import { pluralize } from 'helpers/formatters/string_formats';
import PredictionSummary from 'components/project/prediction_summary';
import ListingQuickUpdateModal from 'components/listing/quick_update/modal';
import { updateListing } from 'components/project/actions';

const listingFieldsIdMap = {
  'condo': 'condosFields',
  'lot': 'lotsFields',
  'lease space': 'leaseFields'
};

export class ListingRollup extends React.Component {
  static propTypes = {
    editLink: PropTypes.string.isRequired,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    history: PropTypes.object.isRequired,
    listings: PropTypes.arrayOf(PropTypes.shape({
      daysLikelyToClose: PropTypes.number,
      estimatedGrossCommission: PropTypes.number,
      percentageLikelyToClose: PropTypes.number
    })).isRequired,
    listingType: PropTypes.string,
    status: PropTypes.string.isRequired,
    updateListing: PropTypes.func.isRequired
  };

  state = {
    listingForEditing: this.props.listings[0],
    expanded: false,
    showListingEditModal: false
  };

  displayName = (listing) => {
    if (listing.address2 && listing.address2.length > 0) return listing.address2;

    return `${this.props.listingType} ${listing.number}`;
  }

  showListingEditModal = (listingForEditing) => {
    this.setState({
      listingForEditing,
      showListingEditModal: true
    });
  };

  goToVoucherTab = () => {
    this.props.history.push('/vouchers');
  }

  handleListingUpdate = (listing) => {
    this.hideListingEditModal();
    this.props.updateListing(listing);
  };

  hideListingEditModal = () => {
    this.setState({ showListingEditModal: false });
  };

  toggleExpanded = () => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  }

  renderGroupHeader() {
    return (
      <Row className="align-items-center py-2 clickable" name="toggle-predictions" onClick={this.toggleExpanded}>
        <Col xs="auto">
          <FontAwesomeIcon
            className={this.props.listings.length === 0 ? 'invisible' : ''}
            icon={this.state.expanded ? faChevronUp : faChevronDown}
          />
        </Col>
        <Col>
          <div className="fw-semibold" name="listings-label">
            {pluralize(this.props.listings.length, this.props.listingType)}
          </div>
        </Col>
        <Col xs="auto">
          <StatusLabel.Pill className="listing-rollup-label" status={this.props.status} />
        </Col>
      </Row>
    );
  }

  renderListings() {
    if (!this.state.expanded) return;
    const { editLink, listings, listingType, status } = this.props;
    const { backoffice, pipeline } = this.props.features;

    return listings.map((listing, index) => {
      const showBorder = index < listings.length - 1;
      const closed = status === 'closed';

      const dropdownItems = [];
      if (backoffice && !closed) {
        dropdownItems.push(
          <Dropdown.Item key="vouchers-tab" name="go-to-voucher-tab" onClick={this.goToVoucherTab}>Go To Vouchers</Dropdown.Item>
        );
      }
      if ((backoffice && !closed) || pipeline) {
        dropdownItems.push(
          <Dropdown.Item key="modal" name="update-prediction-link" onClick={() => this.showListingEditModal(listing)}>
            Update{closed ? '' : ' Prediction'}
          </Dropdown.Item>
        );
      }

      dropdownItems.push(
        <Dropdown.Item href={`${editLink}#${listingFieldsIdMap[listingType.toLowerCase()]}`} key="edit-link">
          Edit {listingType}
        </Dropdown.Item>
      );

      return (
        <div className={`py-4 ${showBorder ? 'border-bottom' : ''}`} key={listing.id}>
          <Row className="align-items-center">
            <Col>
              <strong>{this.displayName(listing)}</strong>
              <span className="text-muted ml-3">{listing.spaceAvailable}</span>
            </Col>

            <Col xs="auto">
              <DropdownButton id={`listing-menu-${listing.id}`} title={<FontAwesomeIcon icon={faEllipsisV} />} variant="ghost">
                {dropdownItems}
              </DropdownButton>
            </Col>
          </Row>

          <PredictionSummary {...listing} />
        </div>
      );
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.renderGroupHeader()}
        {this.renderListings()}

        {this.props.listings.length > 0 &&
          <ListingQuickUpdateModal
            features={this.props.features}
            key={this.state.listingForEditing.id}
            listing={this.state.listingForEditing}
            show={this.state.showListingEditModal}
            onCancel={this.hideListingEditModal}
            onSave={this.handleListingUpdate}
          />
        }
      </React.Fragment>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { updateListing })(withRouter(ListingRollup));
